import { IChatItem } from '../../../../../interfaces';
import { Subscription } from 'rxjs';

export interface IChatsInfo {
  items: IChatItem[];
  page_number: number;
  page_count: number;
  loaded_pages: number[];
  total?: number;
  items_request?: Subscription;
  search_text?: string;
}

export interface IInitChatsParams {
  direction?: 'up' | 'down';
  pagination?: boolean;
  event_scroll?: any;
  position?: number;
  search_text?: string;
  chat_tab?: string;
}

export interface IChatListMenuItem {
  key: string;
  title: string;
  icon: string;
  type: MENU_ITEM_TYPE;
  action?: () => void;
  toggleOptions?: { label: string; value: any }[];
  model?: any;
  onChange?: (event: any) => void;
}

export type CHAT_FILTER_GROUP = 'channel' | 'tag' | 'manager';

/** Id of the "without tags" / "without a manager" option of the chat list filters (`none` on the backend) */
export const CHAT_FILTER_NONE = 'none';

export interface IChatFilterOption {
  id: string;
  name: string;
  img_url?: string;
  color?: string;
}

export enum MENU_ITEM_TYPE {
  TEXT = 'TEXT',
  BUTTON = 'BUTTON',
  TOGGLE = 'TOGGLE',
  CHANNELS_DROPDOWN = 'CHANNELS_DROPDOWN',
  TAGS_DROPDOWN = 'TAGS_DROPDOWN',
  MANAGERS_DROPDOWN = 'MANAGERS_DROPDOWN',
}

export interface IMenuChat {
  title: string;
  icon: string;
  is_svg?: boolean;
  action: () => void;
  is_lines?: boolean;
  submenu?: CHAT_ITEM_SUBMENU;
}

export type CHAT_ITEM_SUBMENU = 'tags' | 'managers';

export enum CHAT_TABS {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  SPAM = 'SPAM',
}

export enum CHAT_SORT {
  IS_NEW = 'IS_NEW',
  IS_UNREAD = 'IS_UNREAD',
}

// Instagram, Facebook and TikTok: direct dialogs (CHATS), post comments (COMMENTS) or both (ALL)
export enum CHAT_CONVERSATION_TYPE {
  ALL = 'ALL',
  CHATS = 'CHATS',
  COMMENTS = 'COMMENTS',
}
